import { render, staticRenderFns } from "./ProjectOptions.vue?vue&type=template&id=c479318c&scoped=true&lang=pug&"
import script from "./ProjectOptions.vue?vue&type=script&lang=ts&"
export * from "./ProjectOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c479318c",
  null
  
)

export default component.exports